import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Landing Page
import LandingPage from './pages/LandingPage';
import ForgotPassword from './pages/ForgotPassword';

// User Pages
import Home from './pages/user/Home';
import UserLogin from './pages/user/UserLogin';
import UserRegister from './pages/user/UserRegister';
import UserProfile from './pages/user/UserProfile';
import SearchPoojari from './pages/user/SearchPoojari';
import PoojariProfile from './pages/user/PoojariProfile';
import CreateBooking from './pages/user/CreateBooking';
import MyBookings from './pages/user/MyBookings';
import MyPayments from './pages/user/MyPayments';
import MyReviews from './pages/user/MyReviews';

// Poojari Pages
import PoojariLogin from './pages/poojari/PoojariLogin';
import PoojariRegister from './pages/poojari/PoojariRegister';
import PoojariDashboard from './pages/poojari/PoojariDashboard';
import PoojariBookings from './pages/poojari/PoojariBookings';
import PoojariProfile2 from './pages/poojari/PoojariProfile2';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminRegister from './pages/admin/AdminRegister';
import AdminDashboard from './pages/admin/AdminDashboard';
import ManagePoojaris from './pages/admin/ManagePoojaris';
import ManageUsers from './pages/admin/ManageUsers';

import './App.css';

/**
 * ============================================================
 * ROUTES - kaunsa page kiske liye
 * ============================================================
 *
 * ⚠️ ProtectedRoute SURAKSHA NAHI HAI - sirf UX hai.
 *
 * Browser ka koi bhi check badla ja sakta hai. Asli suraksha
 * BACKEND ke guards hain (AuthGuard.assertSelf, assertAdmin).
 * Ye bas itna karta hai ki galat banda galat page pe pahunch ke
 * confuse na ho - pehle koi bhi /admin-dashboard URL type karke
 * khol leta tha (khaali/toota hua dikhta, par khulta zaroor).
 *
 * ⚠️ PUBLIC jaan-boojh ke rakhe gaye:
 *   /home, /search, /poojari/:id
 * Kyun: user ko poojari dhoondhna aur profile dekhna hai BOOKING
 * SE PEHLE. Login maang lete to naya banda kuch dekh hi nahi
 * paata aur wapas chala jaata. Booking ke waqt (/book/:id) pe
 * login zaroori hai - wahi sahi jagah hai maangne ki.
 */
function App() {
    return (
        <Router>
            <div className="d-flex flex-column min-vh-100">
                <Navbar />
                <div className="flex-grow-1">
                    <Routes>
                        {/* ===== PUBLIC ===== */}

                        {/* Landing - logged-in banda yahan aaye to
                            LandingPage khud usko dashboard bhej deta hai */}
                        <Route path="/"
                            element={<LandingPage />} />

                        {/* Password reset - user aur poojari dono
                            ke liye ek hi page */}
                        <Route path="/forgot-password"
                            element={<ForgotPassword />} />
                        <Route path="/forgot-password/:role"
                            element={<ForgotPassword />} />

                        {/* ===== USER ===== */}

                        {/* Public - poojari dhoondhna login se pehle */}
                        <Route path="/home"
                            element={<Home />} />
                        <Route path="/login"
                            element={<UserLogin />} />
                        <Route path="/register"
                            element={<UserRegister />} />
                        <Route path="/search"
                            element={<SearchPoojari />} />
                        <Route path="/poojari/:id"
                            element={<PoojariProfile />} />

                        {/* Protected - USER only */}
                        <Route path="/profile"
                            element={
                                <ProtectedRoute allow="USER">
                                    <UserProfile />
                                </ProtectedRoute>
                            } />
                        <Route path="/book/:poojariId"
                            element={
                                <ProtectedRoute allow="USER">
                                    <CreateBooking />
                                </ProtectedRoute>
                            } />
                        <Route path="/my-bookings"
                            element={
                                <ProtectedRoute allow="USER">
                                    <MyBookings />
                                </ProtectedRoute>
                            } />
                        <Route path="/my-payments"
                            element={
                                <ProtectedRoute allow="USER">
                                    <MyPayments />
                                </ProtectedRoute>
                            } />
                        <Route path="/my-reviews"
                            element={
                                <ProtectedRoute allow="USER">
                                    <MyReviews />
                                </ProtectedRoute>
                            } />

                        {/* ===== POOJARI ===== */}

                        <Route path="/poojari-login"
                            element={<PoojariLogin />} />
                        <Route path="/poojari-register"
                            element={<PoojariRegister />} />

                        {/* Protected - POOJARI only */}
                        <Route path="/poojari-dashboard"
                            element={
                                <ProtectedRoute allow="POOJARI">
                                    <PoojariDashboard />
                                </ProtectedRoute>
                            } />
                        <Route path="/poojari-bookings"
                            element={
                                <ProtectedRoute allow="POOJARI">
                                    <PoojariBookings />
                                </ProtectedRoute>
                            } />
                        <Route path="/poojari-profile"
                            element={
                                <ProtectedRoute allow="POOJARI">
                                    <PoojariProfile2 />
                                </ProtectedRoute>
                            } />

                        {/* ===== ADMIN ===== */}

                        <Route path="/admin-login"
                            element={<AdminLogin />} />
                        <Route path="/admin-register"
                            element={<AdminRegister />} />

                        {/* Protected - ADMIN aur SUPER_ADMIN dono.
                            SUPER_ADMIN wahi admin hai jo doosre admins
                            ko approve karta hai - uske paas normal
                            admin ka saara access bhi hai. */}
                        <Route path="/admin-dashboard"
                            element={
                                <ProtectedRoute allow="ADMIN">
                                    <AdminDashboard />
                                </ProtectedRoute>
                            } />
                        <Route path="/admin/poojaris"
                            element={
                                <ProtectedRoute allow="ADMIN">
                                    <ManagePoojaris />
                                </ProtectedRoute>
                            } />
                        <Route path="/admin/users"
                            element={
                                <ProtectedRoute allow="ADMIN">
                                    <ManageUsers />
                                </ProtectedRoute>
                            } />
                    </Routes>
                </div>
                <Footer />
                <ToastContainer
                    position="top-right"
                    autoClose={3000} />
            </div>
        </Router>
    );
}

export default App;